"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var query_exports = {};
__export(query_exports, {
  CollaboratorsQuery: () => CollaboratorsQuery,
  LabelsQuery: () => LabelsQuery,
  MessagesQuery: () => MessagesQuery,
  NotificationContextsQuery: () => NotificationContextsQuery,
  NotificationsQuery: () => NotificationsQuery
});
module.exports = __toCommonJS(query_exports);
var import_fast_equals = require("fast-equals");
var import_init = require("./init");
class BaseQuery {
  static {
    __name(this, "BaseQuery");
  }
  oldQuery;
  oldCallback;
  constructor(dontDestroy) {
    if (dontDestroy !== true) {
      const destroyFn = (0, import_init.getOnDestroy)();
      destroyFn(() => {
        this.unsubscribe();
      });
    }
  }
  _unsubscribe = /* @__PURE__ */ __name(() => {
  }, "_unsubscribe");
  unsubscribe() {
    this._unsubscribe(false);
  }
  query(params, callback) {
    if (!this.needUpdate(params, callback)) {
      return false;
    }
    this.doQuery(params, callback);
    return true;
  }
  doQuery(query, callback) {
    const isUpdate = this.oldQuery !== void 0;
    this._unsubscribe(isUpdate);
    this.oldCallback = callback;
    this.oldQuery = query;
    const { unsubscribe } = this.createQuery(query, callback);
    this._unsubscribe = (isUpdate2) => {
      unsubscribe(isUpdate2);
      this.oldCallback = void 0;
      this.oldQuery = void 0;
      this._unsubscribe = () => {
      };
    };
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  createQuery(params, callback) {
    return {
      unsubscribe: /* @__PURE__ */ __name(() => {
      }, "unsubscribe")
    };
  }
  needUpdate(params, callback) {
    if (!(0, import_fast_equals.deepEqual)(params, this.oldQuery)) return true;
    if (!(0, import_fast_equals.deepEqual)(callback.toString(), this.oldCallback?.toString())) return true;
    return false;
  }
}
class MessagesQuery extends BaseQuery {
  static {
    __name(this, "MessagesQuery");
  }
  createQuery(params, callback) {
    return (0, import_init.getLiveQueries)().queryMessages(params, callback);
  }
}
class NotificationsQuery extends BaseQuery {
  static {
    __name(this, "NotificationsQuery");
  }
  createQuery(params, callback) {
    return (0, import_init.getLiveQueries)().queryNotifications(params, callback);
  }
}
class NotificationContextsQuery extends BaseQuery {
  static {
    __name(this, "NotificationContextsQuery");
  }
  createQuery(params, callback) {
    return (0, import_init.getLiveQueries)().queryNotificationContexts(params, callback);
  }
}
class LabelsQuery extends BaseQuery {
  static {
    __name(this, "LabelsQuery");
  }
  createQuery(params, callback) {
    return (0, import_init.getLiveQueries)().queryLabels(params, callback);
  }
}
class CollaboratorsQuery extends BaseQuery {
  static {
    __name(this, "CollaboratorsQuery");
  }
  createQuery(params, callback) {
    return (0, import_init.getLiveQueries)().queryCollaborators(params, callback);
  }
}
//# sourceMappingURL=query.js.map
